// extracted by mini-css-extract-plugin
export default {"lekkoButton":"login_lekkoButton__2u-XX","lekkoLogo":"login_lekkoLogo__nhi8s","authInput":"login_authInput__E0bha"};